import { QFilters } from "../state/dashboardState";
import * as dashboardAPIUtil from "../../util/dashboard/dashboardAPIUtil";
import { User } from "../../models/User";
import * as artworkAPIUtil from "../../util/artwork/artworkAPIUtil";
import { IQuotesResponse } from "../../interfaces/IQuotesResponse";
import MCatalogueListItem from "../../models/MCatalogueListitem";
import { MArtwork } from "../../models/MArtwork";
import { IArtwork } from "../../interfaces/IArtwork";
import { IDashboardQuote } from "../../interfaces/IDashboardQuote";
import DashboardQuoteListItem from "../../models/DashboardQuoteListItem";
import { IArtFilters } from "../state/artworksState";

export const RECEIVE_QUOTESREQ_APPROVAL_LIST = "[Dashboard] RECEIVE_QUOTESREQ_APPROVAL_LIST";
export const RECEIVE_ORDERSREQ_APPROVAL_LIST = "[Dashboard] RECEIVE_ORDERSREQ_APPROVAL_LIST";
export const IS_LOADING = "[Dashboard] IS_LOADING";
export const FETCH_ERROR = "[Dashboard] FETCH_ERROR";
export const RECEIVE_DASHBOARD_ARTWORK_LIST = "[Dashboard artworks] RECEIVE_DASHBOARD_ARTWORK_LIST";
export const RECEIVE_DASHBOARD_PASTDUEORDER_COUNT = "[Dashboard past due orders count] RECEIVE_DASHBOARD_PASTDUEORDER_COUNT";
export const RECEIVE_CATALOGUE_COUNT = "[Dashboard catalogue count] RECEIVE_CATALOGUE_COUNT";
export const RECEIVE_BILLED_ORDERS_COUNT = "[Dashboard billed order count] RECEIVE_BILLED_ORDERS_COUNT";

export const receivePendingQuotes = (quotes: IDashboardQuote[], count: number, meta: {}) => ({
    type: RECEIVE_QUOTESREQ_APPROVAL_LIST,
    payload: quotes,
});
export const receivePendingOrders = (orders: IDashboardQuote[], count: number, meta: {}) => ({
    type: RECEIVE_ORDERSREQ_APPROVAL_LIST,
    payload: orders,
});
export const isLoading = (loading: boolean) => ({
    type: IS_LOADING,
    loading
});
export const sendFetchError = () => ({
    type: FETCH_ERROR
});
export const fetchQuotesReqApproval = (limit: number = 50,
    offset: number = 0,
    order: string = "productName",
    orient: string = "asc",
    filters: QFilters) => dispatch =>
        dashboardAPIUtil.fetchQuotesReqApproval(limit, offset, order, orient, filters)
            .then(res => {
                const quoteResponse: IQuotesResponse = res.data;
                const catalogueList: IDashboardQuote[] = quoteResponse.data.map(individualCatalogue => {
                    return new DashboardQuoteListItem(individualCatalogue);
                });
                dispatch(receivePendingQuotes(catalogueList, quoteResponse.meta.page_count, quoteResponse.meta))
            }).catch(error => {
                dispatch(isLoading(false));
                dispatch(sendFetchError());
            });

export const fetchOrdersReqApproval = (limit: number = 50,
    offset: number = 0,
    order: string = "productName",
    orient: string = "asc",
    filters: QFilters) => dispatch =>
        dashboardAPIUtil.fetchOrdersReqApproval(limit, offset, order, orient, filters)
            .then(res => {
                const orderResponse: IQuotesResponse = res.data;
                const catalogueList: IDashboardQuote[] = orderResponse.data.map(individualCatalogue => {
                    return new DashboardQuoteListItem(individualCatalogue);
                });
                dispatch(receivePendingOrders(catalogueList, orderResponse.meta.page_count, orderResponse.meta))
            }).catch(error => {
                dispatch(isLoading(false));
                dispatch(sendFetchError());
            });
export const fetchArtworkReqApproval = (
    limit: number = 50,
    offset: number = 0,
    order: string = "",
    orient: string = "asc",
    filters: IArtFilters
) => (dispatch) => (
    artworkAPIUtil.fetchArtworks(limit, offset, order, orient, filters)
        .then(res => {
            const artworks = {};
            res.data.data.forEach((individualArtwork, key) => {
                const modeledArtwork = new MArtwork(individualArtwork);
                artworks[key] = modeledArtwork;
            });
            dispatch(receiveArtworks(artworks));
        }).catch(error => {
            console.log("Error in fetching Artwork", error);
            dispatch(isLoading(false));
        })
)
export const receiveArtworks = (artworks: { [key: string]: IArtwork }) => ({
    type: RECEIVE_DASHBOARD_ARTWORK_LIST,
    payload: artworks,
});

export const receiveCataloguesCount = (count) => ({
    type: RECEIVE_CATALOGUE_COUNT,
    payload: count,
});
export const fetchCataloguesCount = (session) => dispatch => dashboardAPIUtil.fetchCatalogues(session)
    .then(res => {
        if (res.data) {
            if (res.data.meta) {
                dispatch(receiveCataloguesCount(res.data.meta.total_count))
            }
        }
    }).catch(error => {
        dispatch(isLoading(false));
        dispatch(sendFetchError());
    });
export const fetchPastDueOrdersCount = (session) => dispatch => dashboardAPIUtil.fetchPastDueOrdersCount(session)
    .then(res => {
        dispatch(receivePastDueOrdersCount(res.data.count))
    }).catch(error => {
        dispatch(isLoading(false));
        dispatch(sendFetchError());
    });
export const receivePastDueOrdersCount = (count) => ({
    type: RECEIVE_DASHBOARD_PASTDUEORDER_COUNT,
    payload: count,
});
export const fetchBilledOrdersCount = (session) => dispatch => dashboardAPIUtil.fetchBilledOrdersCount(session)
    .then(res => {
        dispatch(receiveBilledOrdersCount(res.data.count))
    }).catch(error => {
        dispatch(isLoading(false));
        dispatch(sendFetchError());
    });
export const receiveBilledOrdersCount = (count) => ({
    type: RECEIVE_BILLED_ORDERS_COUNT,
    payload: count,
});